import { BindingCreator } from '@dreryk/react-common';
import { Checkbox } from '@dreryk/react-components';

import { translationKeys } from '../../../../translations';

const FIELD_NAME = 'patientPortal';

export type PredefinedPatientGroupsPatientPortalFormBeanPart = {
   [FIELD_NAME]: boolean;
};

type PredefinedPatientGroupsPatientPortalFieldProps = {
   readonly register: BindingCreator<PredefinedPatientGroupsPatientPortalFormBeanPart, typeof FIELD_NAME>;
};

export const PredefinedPatientGroupsPatientPortalField = (
   props: PredefinedPatientGroupsPatientPortalFieldProps
): JSX.Element => {
   return (
      <Checkbox controller={props.register(FIELD_NAME)} testId={FIELD_NAME} label={translationKeys.patientPortal} />
   );
};
